"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatSelectionPassenger = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'seat-selection-passenger';
class SeatSelectionPassenger extends react_1.default.PureComponent {
    render() {
        const { passengerName, seatLabel, selected, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, [
            modificators,
            selected ? 'selected' : undefined,
        ]);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__passenger`, onClick: this.props.onClick }, passengerName),
                seatLabel && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: `${className}__seat`, onClick: this.props.onClick }, seatLabel),
                    react_1.default.createElement("button", { className: `${className}__reset`, onClick: this.props.onResetClick },
                        react_1.default.createElement(Icon_1.Icon, { name: 'x' })))))));
    }
}
exports.SeatSelectionPassenger = SeatSelectionPassenger;
SeatSelectionPassenger.defaultProps = {
    firstName: '',
    lastName: '',
    seatLabel: '',
    selected: false,
    onClick: () => {
    },
};
//# sourceMappingURL=index.js.map